module.exports = __webpack_public_path__ + "img/user1.ca50dde2.png";